import styled, { css } from 'styled-components/macro'

export const StyledSVG = styled.div<{
  $visible: boolean
  $preserveIconStyles?: boolean
}>`
  ${({ $preserveIconStyles }) =>
    !$preserveIconStyles &&
    css`
      svg {
        width: 18px;
        height: 18px;
      }
    `}
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};

  svg:focus {
    outline: none;
  }

  svg:focus-visible {
    outline: none;
  }
`
